import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { QuestionT } from 'src/api/types/QuestionT';
import { Portal } from 'src/frames/components/Portal';
import { CloseIcon } from 'src/frames/icons/CloseIcon';
import { cn } from 'src/frames/utils/cn';
import './HintView.scss';

type PropsT = {
  className?: any;
  setShowHint: (showHint: boolean) => void;
};

type DefaultPropsT = {
  question: QuestionT;
  questionDisplayNr: number;
  portalElm: any;
};

export const HintView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div className={cn('HintView', props.className)}>
        <Portal elm={props.portalElm}>
          <div
            className={cn('HintView__TitleInPortal', 'flex flex-row', 'flex-1')}
          >
            <div className="flex-1 text-center">{props.question.hintTitle}</div>
            <div className={cn('HintView__CloseButton', 'ml-2')}>
              <button onClick={() => props.setShowHint(false)}>
                <CloseIcon />
              </button>
            </div>
          </div>
        </Portal>
        <div className={cn('HintView__Card', 'flex flex-col', 'px-4 py-2')}>
          <div className={cn('HintView__Body')}>{props.question.hint}</div>
          <button
            className={cn('HintView__Button', 'mt-6')}
            onClick={() => props.setShowHint(false)}
          >
            Verstanden
          </button>
        </div>
      </div>
    );
  })
);
